/**
 * Política de validación de formularios "Create Report" (cardiac, echo, etc.)
 * según `users.use_type` (1 carácter, mismo origen que TeleradAPI `User.UseType`).
 *
 * - **A** = Administración / oficina — validación estricta (misma que doctor)
 * - **D** = Doctor — validación completa
 * - **T** = Técnico — H&P riesgo/síntomas opcionales; primary care y altura opcionales
 * - Otros = estricto
 */
export const FORM_ROLE = {
  ADMIN: 'A',
  DOCTOR: 'D',
  TECH: 'T',
  MANAGER: 'M',
} as const;

export type FormRoleCode = (typeof FORM_ROLE)[keyof typeof FORM_ROLE] | string;

export interface CreateFormFieldPolicy {
  requireHistoryIndicationMedications: boolean;
  requireRiskAndSymptomsAfter: boolean;
  primaryCareOptional: boolean;
  heightOptional: boolean;
  showTechnicianModeHint: boolean;
  labelKey: 'strict' | 'technician';
}

const STRICT: CreateFormFieldPolicy = {
  requireHistoryIndicationMedications: true,
  requireRiskAndSymptomsAfter: true,
  primaryCareOptional: false,
  heightOptional: false,
  showTechnicianModeHint: false,
  labelKey: 'strict',
};

const TECH: CreateFormFieldPolicy = {
  requireHistoryIndicationMedications: false,
  requireRiskAndSymptomsAfter: false,
  primaryCareOptional: true,
  heightOptional: true,
  showTechnicianModeHint: false,
  labelKey: 'technician',
};

/**
 * @param useType `user.useType` (API / login). Si falta, validación estricta.
 */
export function getCreateFormFieldPolicy(useType: string | undefined | null): CreateFormFieldPolicy {
  const t = (useType ?? '').trim().toUpperCase();
  if (t === FORM_ROLE.TECH) return { ...TECH };
  return { ...STRICT };
}
